import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
export function SliderInput({ id, label, value, onChange, min = 0, max = 10, step = 1, minLabel, maxLabel, className = 'brutal-slider', }) {
    const handleChange = useCallback((e) => {
        onChange(parseFloat(e.target.value));
    }, [onChange]);
    const sliderStyle = {
        WebkitAppearance: 'none',
        appearance: 'none',
        width: '100%',
        maxWidth: '320px',
        height: '4px',
        background: '#333333',
        borderRadius: 0,
        outline: 'none',
        cursor: 'pointer',
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.375rem', maxWidth: '320px' }, children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'spaceBetween', alignItems: 'center' }, children: [_jsx("label", { htmlFor: id, style: {
                            fontSize: '0.75rem',
                            fontWeight: '600',
                            color: '#999999',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                        }, children: label }), _jsxs("span", { style: { fontFamily: '"Fira Code", "JetBrains Mono", monospace', color: '#06b6d4', fontSize: '0.75rem' }, children: [value, "/", max] })] }), _jsx("input", { id: id, type: "range", min: min, max: max, step: step, value: value, onChange: handleChange, style: sliderStyle }), (minLabel || maxLabel) && (_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'spaceBetween',
                    fontSize: '0.625rem',
                    color: '#666666',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                }, children: [_jsx("span", { children: minLabel || min }), _jsx("span", { children: maxLabel || max })] }))] }));
}
